module.exports = "/_next/static/images/072daf6a6be4d36383b21a689ee0f85b-debit-card-lg.svg.webp";